import { render, staticRenderFns } from "./MyPromoteTips.vue?vue&type=template&id=0533a394&"
import script from "./MyPromoteTips.vue?vue&type=script&lang=js&"
export * from "./MyPromoteTips.vue?vue&type=script&lang=js&"
import style0 from "./MyPromoteTips.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports